import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

/**
 * Проверка входит ли указанная дата в диапазон
 *
 * @param dateFromString
 * @param dateToString
 * @param dateString
 * @param format
 */
const checkDateInRange = function (dateFromString, dateToString, dateString, format = 'DD.MM.YYYY') {
  let dateFrom = moment(dateFromString, format).startOf('day')
  let dateTo = moment(dateToString, format).endOf('day')
  let date = moment(dateString, format)
  let range = moment().range(dateFrom, dateTo)

  return range.contains(date)
}

export default checkDateInRange



// WEBPACK FOOTER //
// ./src/helpers/checkDateInRange.js